// // scoreUtils.js — Central score computation, domain breakdown, and risk derivation
// // All calculations are driven by mockData.json — no hardcoded scores

// import assessmentData from '../mockdata/assessment/mockData.json';

// // ─────────────────────────────────────────────────────────
// // DOMAIN DEFINITIONS
// // Maps each assessment type to labelled groups of question IDs
// // so the ResultsScreen can break the total score into sub-scores
// // ─────────────────────────────────────────────────────────

// const DOMAIN_MAP = {
//   mental: [
//     { icon: '😔', bg: '#EDE9FE', name: 'Mood & Interest',      questionIds: ['interest', 'depressed', 'failure', 'lossOfInterest'] },
//     { icon: '😴', bg: '#DBEAFE', name: 'Sleep & Energy',       questionIds: ['sleep', 'energy'] },
//     { icon: '🍽️', bg: '#D1FAE5', name: 'Physical Symptoms',   questionIds: ['appetite', 'movement'] },
//     { icon: '🧠', bg: '#FEF3C7', name: 'Cognitive Function',   questionIds: ['concentration'] },
//     { icon: '⚠️', bg: '#FEE2E2', name: 'Critical (Q9)',        questionIds: ['thoughts'] },
//   ],
//   anxiety: [
//     { icon: '😰', bg: '#FEE2E2', name: 'Worry & Control',      questionIds: ['nervous', 'control_worry', 'too_much_worry'] },
//     { icon: '🧘', bg: '#EDE9FE', name: 'Relaxation & Rest',    questionIds: ['relaxing', 'restless'] },
//     { icon: '😤', bg: '#FEF3C7', name: 'Irritability & Fear',  questionIds: ['irritable', 'afraid'] },
//   ],
//   fertility: [
//     { icon: '📅', bg: '#EDE9FE', name: 'Menstrual Health',     questionIds: ['menstrual_reg'] },
//     { icon: '⚖️', bg: '#FEF3C7', name: 'Weight & Hormones',   questionIds: ['weight_metabolic', 'pcos_symptoms'] },
//     { icon: '🧘', bg: '#D1FAE5', name: 'Lifestyle & Stress',   questionIds: ['stress_emotional', 'lifestyle'] },
//     { icon: '🌱', bg: '#DBEAFE', name: 'Reproductive History', questionIds: ['reproductive_history'] },
//   ],
//   thyroid: [
//     { icon: '⚖️', bg: '#FEF3C7', name: 'Metabolism & Weight',  questionIds: ['weight_metabolism', 'fatigue'] },
//     { icon: '🌡️', bg: '#FEE2E2', name: 'Temperature & Cycle', questionIds: ['temperature', 'menstrual_hormonal'] },
//     { icon: '💆', bg: '#EDE9FE', name: 'Skin, Hair & Mood',    questionIds: ['skin_hair', 'mood_mental'] },
//     { icon: '❤️', bg: '#FFE4E6', name: 'Heart & Physical',     questionIds: ['heart_physical'] },
//   ],
//   lifestyle: [
//     { icon: '🏃', bg: '#D1FAE5', name: 'Physical Activity',    questionIds: ['activity_minutes', 'sitting_time'] },
//     { icon: '🥗', bg: '#FEF3C7', name: 'Nutrition & Diet',     questionIds: ['fruits_veg', 'junk_food', 'water_intake'] },
//     { icon: '🚭', bg: '#FEE2E2', name: 'Substance Use',        questionIds: ['smoking', 'alcohol'] },
//     { icon: '🩺', bg: '#EDE9FE', name: 'Preventive Care',      questionIds: ['chronic_conditions', 'checkups', 'screening'] },
//   ],
//   hormonal: [
//     { icon: '📅', bg: '#EDE9FE', name: 'Menstrual & Fertility', questionIds: ['menstrual_irreg'] },
//     { icon: '⚖️', bg: '#FEF3C7', name: 'Weight & Skin',         questionIds: ['weight_metabolic', 'skin_hair'] },
//     { icon: '⚡', bg: '#D1FAE5', name: 'Energy & Mood',          questionIds: ['energy_fatigue', 'mood'] },
//     { icon: '🌡️', bg: '#FEE2E2', name: 'Temperature & Sweats',  questionIds: ['temperature_hormonal'] },
//   ],
//   diabetes: [
//     { icon: '⚖️', bg: '#FEF3C7', name: 'BMI & Activity',         questionIds: ['bmi_q', 'activity'] },
//     { icon: '🥗', bg: '#D1FAE5', name: 'Diet & Family History',   questionIds: ['diet', 'family_history'] },
//     { icon: '👩', bg: '#EDE9FE', name: 'Women-Specific Risk',     questionIds: ['women_specific'] },
//     { icon: '❤️', bg: '#FEE2E2', name: 'Blood Pressure & Age',    questionIds: ['blood_pressure', 'age'] },
//   ],
//   bmi: [
//     { icon: '⚖️', bg: '#FEF3C7', name: 'BMI & Waist',            questionIds: ['bmi_q', 'waist'] },
//     { icon: '🏃', bg: '#D1FAE5', name: 'Activity & Diet',         questionIds: ['activity', 'diet'] },
//     { icon: '❤️', bg: '#FEE2E2', name: 'BP & Blood Sugar',        questionIds: ['blood_pressure', 'blood_sugar'] },
//     { icon: '👩', bg: '#EDE9FE', name: 'Women-Specific',          questionIds: ['women_metabolic'] },
//   ],
//   sleep: [
//     { icon: '🌙', bg: '#EDE9FE', name: 'Duration & Onset',        questionIds: ['duration', 'onset'] },
//     { icon: '😴', bg: '#DBEAFE', name: 'Night Awakenings',        questionIds: ['awakenings'] },
//     { icon: '☀️', bg: '#FEF3C7', name: 'Daytime Function',        questionIds: ['quality_perception', 'daytime_fatigue'] },
//     { icon: '🌸', bg: '#FFE4E6', name: 'Hormonal Impact',         questionIds: ['hormonal_sleep'] },
//   ],
//   stress: [
//     { icon: '😓', bg: '#FEE2E2', name: 'Overwhelm & Emotions',    questionIds: ['overwhelmed', 'emotional_stress'] },
//     { icon: '🌙', bg: '#EDE9FE', name: 'Sleep Impact',            questionIds: ['stress_sleep'] },
//     { icon: '🤕', bg: '#FEF3C7', name: 'Physical Symptoms',       questionIds: ['physical_symptoms'] },
//     { icon: '🌸', bg: '#D1FAE5', name: 'Hormonal & Work Stress',  questionIds: ['hormonal_stress', 'work_life'] },
//   ],
//   social: [
//     { icon: '🏠', bg: '#EDE9FE', name: 'Housing & Finance',       questionIds: ['housing', 'financial'] },
//     { icon: '🥗', bg: '#D1FAE5', name: 'Food & Healthcare',       questionIds: ['food', 'healthcare_access'] },
//     { icon: '🤝', bg: '#DBEAFE', name: 'Support & Safety',        questionIds: ['support', 'safety'] },
//     { icon: '📚', bg: '#FEF3C7', name: 'Literacy & Caregiving',   questionIds: ['education', 'caregiving'] },
//   ],
//   general: [
//     { icon: '🏃', bg: '#D1FAE5', name: 'Activity & Weight',       questionIds: ['activity', 'weight'] },
//     { icon: '🥗', bg: '#FEF3C7', name: 'Nutrition & Sleep',       questionIds: ['nutrition', 'sleep'] },
//     { icon: '🧠', bg: '#EDE9FE', name: 'Mental & Hormonal',       questionIds: ['stress', 'hormonal', 'energy'] },
//     { icon: '🩺', bg: '#FEE2E2', name: 'Chronic & Preventive',    questionIds: ['chronic', 'substance', 'preventive'] },
//   ],
//   // Legacy (no score engine — domains are static in RESULT_CONFIG)
//   menopause: [], pcos: [], pregnancy: [], menstrual: [],
// };

// // ─────────────────────────────────────────────────────────
// // RISK FACTOR LABELS
// // Derives risk factors from actual user answers
// // ─────────────────────────────────────────────────────────

// const RISK_FACTOR_BUILDERS = {
//   mental: (allAnswers) => {
//     const all = { ...allAnswers.s1, ...allAnswers.s2 };
//     const factors = [];
//     const lookup = (id) => {
//       for (const screen of assessmentData.mental.screens) {
//         const q = screen.questions.find((q) => q.id === id);
//         if (q) {
//           const opt = q.options.find((o) => o.label === all[id]);
//           return opt?.score ?? 0;
//         }
//       }
//       return 0;
//     };
//     if (lookup('depressed') >= 2)     factors.push({ icon: '😔', bg: '#FEE2E2', name: 'Persistent low mood / hopelessness',   val: `+${lookup('depressed') * 3}` });
//     if (lookup('sleep') >= 2)         factors.push({ icon: '😴', bg: '#EDE9FE', name: 'Significant sleep disturbance',         val: `+${lookup('sleep') * 2}` });
//     if (lookup('energy') >= 2)        factors.push({ icon: '⚡', bg: '#FEF3C7', name: 'Fatigue / low energy',                  val: `+${lookup('energy') * 2}` });
//     if (lookup('concentration') >= 2) factors.push({ icon: '🧠', bg: '#DBEAFE', name: 'Difficulty concentrating',              val: `+${lookup('concentration') * 2}` });
//     if (lookup('thoughts') > 0)       factors.push({ icon: '🚨', bg: '#FEE2E2', name: '⚠️ Thoughts of self-harm (Q9)',         val: 'URGENT' });
//     if (factors.length === 0)         factors.push({ icon: '✅', bg: '#D1FAE5', name: 'No significant risk factors identified', val: '0' });
//     return factors;
//   },
//   anxiety: (allAnswers) => {
//     const all = { ...allAnswers.s1, ...allAnswers.s2 };
//     const score = (id) => {
//       for (const s of assessmentData.anxiety.screens) {
//         const q = s.questions.find((q) => q.id === id);
//         if (q) return q.options.find((o) => o.label === all[id])?.score ?? 0;
//       }
//       return 0;
//     };
//     const factors = [];
//     if (score('nervous') >= 2)        factors.push({ icon: '😰', bg: '#FEE2E2', name: 'Persistent anxiety / nervousness',       val: `+${score('nervous') * 3}` });
//     if (score('control_worry') >= 2)  factors.push({ icon: '🌀', bg: '#EDE9FE', name: 'Uncontrollable worry',                   val: `+${score('control_worry') * 3}` });
//     if (score('restless') >= 2)       factors.push({ icon: '😤', bg: '#FEF3C7', name: 'Restlessness',                           val: `+${score('restless') * 2}` });
//     if (score('afraid') >= 2)         factors.push({ icon: '😨', bg: '#FEE2E2', name: 'Fear / sense of dread',                  val: `+${score('afraid') * 2}` });
//     if (factors.length === 0)         factors.push({ icon: '✅', bg: '#D1FAE5', name: 'No significant anxiety indicators',       val: '0' });
//     return factors;
//   },
//   _generic: (type, allAnswers) => {
//     // Generic: iterate all scored questions, surface those with score ≥ 2
//     const conf = assessmentData[type];
//     if (!conf) return [];
//     const factors = [];
//     conf.screens.forEach((screen, sIdx) => {
//       const stepData = allAnswers[`s${sIdx + 1}`] || {};
//       screen.questions.forEach((q) => {
//         if (!q.scored) return;
//         const answer = stepData[q.id];
//         if (!answer) return;
//         const opt = q.options?.find((o) => o.label === answer);
//         if (opt && opt.score >= 2) {
//           factors.push({
//             icon: '⚠️', bg: '#FEF3C7',
//             name: q.label.replace(/^\d+\.\s*/, '').slice(0, 60) + (q.label.length > 63 ? '…' : ''),
//             val: `+${opt.score}`,
//           });
//         }
//       });
//     });
//     if (factors.length === 0) factors.push({ icon: '✅', bg: '#D1FAE5', name: 'No significant risk factors identified', val: '0' });
//     return factors.slice(0, 6); // cap at 6 for display
//   },
// };

// // ─────────────────────────────────────────────────────────
// // PUBLIC API
// // ─────────────────────────────────────────────────────────

// /**
//  * computeScore — score engine driven entirely by mockData.json
//  */
// export const computeScore = (type, allAnswers) => {
//   const engine = assessmentData.scoreEngine?.[type];
//   const conf   = assessmentData[type];
//   if (!engine || !conf) return null;

//   let total = 0;
//   conf.screens.forEach((screen, sIdx) => {
//     const stepData = allAnswers[`s${sIdx + 1}`] || {};
//     screen.questions.forEach((q) => {
//       if (!q.scored) return;
//       const answer = stepData[q.id];
//       if (answer == null) return;
//       const matched = q.options?.find((o) =>
//         (typeof o === 'object' ? o.label : o) === answer
//       );
//       if (matched && typeof matched.score === 'number') total += matched.score;
//     });
//   });

//   const range =
//     engine.ranges.find((r) => total >= r.min && total <= r.max) ||
//     engine.ranges[engine.ranges.length - 1];

//   return {
//     raw:         total,
//     max:         engine.maxScore,
//     percent:     Math.round((total / engine.maxScore) * 100),
//     label:       range.label,
//     color:       range.color,
//     risk:        range.risk,
//     ranges:      engine.ranges,
//     redFlagNote: engine.redFlagNote || null,
//   };
// };

// /**
//  * computeDomains — breaks total score into named sub-domains
//  * Returns array of { icon, bg, name, score (0–100), maxRaw, rawScore, lvl, lvlColor, barColor }
//  */
// export const computeDomains = (type, allAnswers) => {
//   const domainDefs = DOMAIN_MAP[type];
//   if (!domainDefs || domainDefs.length === 0) return [];

//   const conf = assessmentData[type];
//   if (!conf) return [];

//   // Build a flat lookup: questionId → { question, stepData }
//   const qMap = {};
//   conf.screens.forEach((screen, sIdx) => {
//     const stepData = allAnswers[`s${sIdx + 1}`] || {};
//     screen.questions.forEach((q) => {
//       qMap[q.id] = { q, stepData };
//     });
//   });

//   return domainDefs.map((domain) => {
//     let rawScore = 0;
//     let maxRaw   = 0;

//     domain.questionIds.forEach((qid) => {
//       const entry = qMap[qid];
//       if (!entry) return;
//       const { q, stepData } = entry;
//       if (!q.scored || !q.options) return;

//       // max possible score for this question
//       const maxOpt = Math.max(...q.options.map((o) => typeof o === 'object' ? (o.score ?? 0) : 0));
//       maxRaw += maxOpt;

//       const answer = stepData[q.id];
//       if (!answer) return;
//       const opt = q.options.find((o) => (typeof o === 'object' ? o.label : o) === answer);
//       if (opt && typeof opt.score === 'number') rawScore += opt.score;
//     });

//     const pct = maxRaw > 0 ? Math.round((rawScore / maxRaw) * 100) : 0;
//     const { lvl, lvlColor, barColor } = severityFromPercent(pct);

//     return {
//       icon:     domain.icon,
//       bg:       domain.bg,
//       name:     domain.name,
//       score:    pct,
//       rawScore,
//       maxRaw,
//       lvl,
//       lvlColor,
//       barColor,
//     };
//   });
// };

// /**
//  * computeRiskFactors — derives risk factors from actual answers
//  */
// export const computeRiskFactors = (type, allAnswers) => {
//   if (RISK_FACTOR_BUILDERS[type]) {
//     return RISK_FACTOR_BUILDERS[type](allAnswers);
//   }
//   return RISK_FACTOR_BUILDERS._generic(type, allAnswers);
// };

// /**
//  * buildReviewSections — generates review section list from mockData screens
//  */
// export const buildReviewSections = (type) => {
//   const conf = assessmentData[type];
//   if (!conf || !Array.isArray(conf.screens)) return [];
//   return conf.screens.map((screen) => ({
//     label: screen.title,
//     step:  screen.id,
//   }));
// };

// /**
//  * getAssessmentMeta — returns { label, icon, color, description } for a type id
//  */
// export const getAssessmentMeta = (type) =>
//   assessmentData.assessmentTypes.find((a) => a.id === type) || { label: type, icon: '🩺', color: '#5B21B6' };

// // ─────────────────────────────────────────────────────────
// // INTERNAL HELPERS
// // ─────────────────────────────────────────────────────────

// const severityFromPercent = (pct) => {
//   if (pct <= 20) return { lvl: 'Low',      lvlColor: '#059669', barColor: '#059669' };
//   if (pct <= 40) return { lvl: 'Mild',     lvlColor: '#16A34A', barColor: '#16A34A' };
//   if (pct <= 60) return { lvl: 'Moderate', lvlColor: '#D97706', barColor: '#D97706' };
//   if (pct <= 80) return { lvl: 'High',     lvlColor: '#DC2626', barColor: '#DC2626' };
//   return            { lvl: 'Severe',    lvlColor: '#7F1D1D', barColor: '#7F1D1D' };
// };

// export default { computeScore, computeDomains, computeRiskFactors, buildReviewSections, getAssessmentMeta };
// scoreUtils.js  — LifeStagesConditions.json score engine
//
// ─── HOW ANSWERS ARE STORED (from HealthAssessments.jsx) ───────────────────
//
//  updateAnswer(screenTitle, field, value)
//    screenTitle = screenConf.title = group.group   e.g. "Menstrual Health"
//    field       = question.id                      e.g. "pub_mens_q1"
//    value       = whatever GenericScreen passes    ← THIS is the variable part
//
//  So allAnswers looks like:
//  {
//    "Menstrual Health": {
//      "pub_mens_q1": <value>,   // could be option.id OR option.label
//      ...
//    }
//  }
//
// scoreUtils must handle BOTH cases (option.id match AND option.label match)
// so it works regardless of what GenericScreen passes as `value`.
// ───────────────────────────────────────────────────────────────────────────

import lifeStageData from '../components/common/LifeStagesConditions.json';

// ─── Flat list of every conditionGroup across all life stages ────────────────
const ALL_GROUPS = lifeStageData.lifeStages.flatMap((stage) =>
  (stage.conditionGroups || []).map((g) => ({
    ...g,
    stageId:       stage.id,
    stageLabel:    stage.label,
    stageAgeRange: stage.ageRange,
  }))
);

// ─── Find a group by its `group` display title (= allAnswers top-level key) ──
const findGroupByTitle = (title) =>
  ALL_GROUPS.find((g) => g.group === title) ?? null;

// ─── Resolve an option from a question by EITHER option.id OR option.label ──
//     GenericScreen may pass either — we match both so scoring never returns 0
//     just because of a label-vs-id mismatch.
const resolveOption = (question, value) => {
  if (value == null || value === '') return null;
  const opts = question.options || [];

  // 1. Exact id match
  let opt = opts.find((o) => o.id === value);
  if (opt) return opt;

  // 2. Exact label match
  opt = opts.find((o) => o.label === value);
  if (opt) return opt;

  // 3. Case-insensitive label match (safety net)
  const lower = String(value).toLowerCase();
  opt = opts.find((o) => String(o.label).toLowerCase() === lower);
  return opt ?? null;
};

const scoreForValue  = (question, value) => resolveOption(question, value)?.score ?? 0;
// console.log(scoreForValue,"this is the score for value")

const maxScoreForQ   = (question)        =>
  Math.max(0, ...(question.options || []).map((o) => o.score ?? 0));
// console.log(maxScoreForQ)
// ─── Severity helpers ────────────────────────────────────────────────────────
const SEVERITY = [
  { max: 20,  label: 'Low',      color: '#059669' },
  { max: 40,  label: 'Mild',     color: '#16A34A' },
  { max: 60,  label: 'Moderate', color: '#D97706' },
  { max: 80,  label: 'High',     color: '#DC2626' },
  { max: 100, label: 'Severe',   color: '#7F1D1D' },
];
const severityFromPct = (pct) =>
  SEVERITY.find((s) => pct <= s.max) ?? SEVERITY[SEVERITY.length - 1];

const SCORE_RANGES = [
  { min: 0,  max: 20,  label: 'Low Concern',     risk: 'low',      color: '#059669' },
  { min: 21, max: 40,  label: 'Mild Concern',     risk: 'mild',     color: '#16A34A' },
  { min: 41, max: 60,  label: 'Moderate Concern', risk: 'moderate', color: '#D97706' },
  { min: 61, max: 80,  label: 'High Concern',      risk: 'high',     color: '#DC2626' },
  { min: 81, max: 100, label: 'Severe Concern',    risk: 'severe',   color: '#7F1D1D' },
];
const rangeFromPct = (pct) =>
  SCORE_RANGES.find((r) => pct >= r.min && pct <= r.max) ??
  SCORE_RANGES[SCORE_RANGES.length - 1];

// ────────────────────────────────────────────────────────────────────────────
// computeScore
// ────────────────────────────────────────────────────────────────────────────
export const computeScore = (assessmentType, allAnswers) => {
  // ── 1. Find the group ──────────────────────────────────────────────────────
  const group = findGroupByTitle(assessmentType);

  // DEBUG — remove after confirming scores work
  if (!group) {
    // console.warn(
    //   '[scoreUtils] computeScore: no group found for assessmentType =',
    //   JSON.stringify(assessmentType),
    //   '\nKnown group titles:',
    //   ALL_GROUPS.map((g) => g.group),
    // );
    return null;
  }

  // ── 2. Pull this group's answers out of allAnswers ─────────────────────────
  //    allAnswers key = group.group (set by makeChangeHandler(screenConf.title))
  const answers   = allAnswers[assessmentType] || {};
  const questions = group.questions || [];

  // DEBUG — open browser console to see this
  console.group(`[scoreUtils] computeScore — "${assessmentType}"`);
  console.log('allAnswers keys  :', Object.keys(allAnswers));
  console.log('answers for group:', answers);

  let raw         = 0;
  let maxPossible = 0;
  const redFlags  = [];

  questions.forEach((q) => {
    const value = answers[q.id]; // whatever GenericScreen stored

    if (q.redFlag) {
      const resolved = resolveOption(q, value);
      // A red flag fires when the user picked the "yes" option
      // We detect this by option.id === 'yes' OR option.label === 'Yes'
      const fired =
        resolved?.id === 'yes' ||
        String(resolved?.label || '').toLowerCase() === 'yes';
      if (fired) {redFlags.push(q.label.replace(/^\d+\.\s*/, ''));

      }
      const RED_FLAG_WEIGHT=20;
      const score=fired?RED_FLAG_WEIGHT:0;
      raw+=score;
      maxPossible+=RED_FLAG_WEIGHT;
      
      console.log(`  [redFlag] q="${q.id}" value="${value}" fired=${fired}`);
      return;
    }

    const score = scoreForValue(q, value);
    const max   = maxScoreForQ(q);
    raw         += score;
    maxPossible += max;

    // DEBUG — shows exactly what each question contributed
    // console.log(
    //   `  q="${q.id}" stored="${value}" → score=${score}/${max}`,
    //   resolveOption(q, value) ? '' : '⚠️ NO OPTION MATCHED',
    // );
  });

  const percent = maxPossible > 0 ? Math.round((raw / maxPossible) * 100) : 0;
  const range   = rangeFromPct(percent);

  // console.log(`  TOTAL: ${raw}/${maxPossible} = ${percent}%  → "${range.label}"`);
  console.groupEnd();

  return {
    raw,
    max:         maxPossible,
    percent,
    label:       range.label,
    color:       range.color,
    risk:        range.risk,
    ranges:      SCORE_RANGES,
    redFlags,
    redFlagNote: redFlags.length > 0
      ? ` ${redFlags.length} red flag${redFlags.length > 1 ? 's' : ''} detected — please consult a doctor promptly.`
      : null,
  };
};

// ────────────────────────────────────────────────────────────────────────────
// computeDomains
// ────────────────────────────────────────────────────────────────────────────
export const computeDomains = (assessmentType, allAnswers) => {
  const group = findGroupByTitle(assessmentType);
  if (!group) return [];

  const answers  = allAnswers[assessmentType] || {};
  const regular  = (group.questions || []).filter((q) => !q.redFlag);
  const flagQs   = (group.questions || []).filter((q) => q.redFlag);

  const buildDomain = (qs, icon, bg, name) => {
    let rawScore = 0, maxRaw = 0;
    qs.forEach((q) => {
      maxRaw   += maxScoreForQ(q);
      rawScore += scoreForValue(q, answers[q.id]);
    });
    const pct = maxRaw > 0 ? Math.round((rawScore / maxRaw) * 100) : 0;
    const sev = severityFromPct(pct);
    return { icon, bg, name, score: pct, rawScore, maxRaw,
             lvl: sev.label, lvlColor: sev.color, barColor: sev.color };
  };

  const domains = [];
  if (regular.length > 0)
    domains.push(buildDomain(regular, '📋', '#EDE9FE', 'Symptom Score'));

  if (flagQs.length > 0) {
    const firedCount = flagQs.filter((q) => {
      const resolved = resolveOption(q, answers[q.id]);
      return resolved?.id === 'yes' ||
             String(resolved?.label || '').toLowerCase() === 'yes';
    }).length;
    const pct = Math.round((firedCount / flagQs.length) * 100);
    domains.push({
      icon: '🚨', bg: '#FEE2E2', name: 'Red Flag Alerts',
      score: pct, rawScore: firedCount, maxRaw: flagQs.length,
      lvl:      firedCount > 0 ? 'Alert' : 'Clear',
      lvlColor: firedCount > 0 ? '#DC2626' : '#059669',
      barColor: firedCount > 0 ? '#DC2626' : '#059669',
    });
  }
  return domains;
};

// ────────────────────────────────────────────────────────────────────────────
// computeRiskFactors
// ────────────────────────────────────────────────────────────────────────────
export const computeRiskFactors = (assessmentType, allAnswers) => {
  const group = findGroupByTitle(assessmentType);
  if (!group) return [];

  const answers   = allAnswers[assessmentType] || {};
  const questions = group.questions || [];
  const factors   = [];

  questions.forEach((q) => {
    const value    = answers[q.id];
    const resolved = resolveOption(q, value);
    if (!resolved) return;

    if (q.redFlag) {
      const fired =
        resolved.id === 'yes' ||
        String(resolved.label || '').toLowerCase() === 'yes';
      if (fired) {
        factors.push({
          icon: '🚨', bg: '#FEE2E2',
          name: q.label.replace(/^\d+\.\s*/, '').slice(0, 70),
          val:  'RED FLAG',
        });
      }
      return;
    }

    const score = resolved.score ?? 0;
    const max   = maxScoreForQ(q);
    if (max > 0 && score / max >= 0.67) {
      factors.push({
        icon: '⚠️', bg: '#FEF3C7',
        name: q.label.replace(/^\d+\.\s*/, '').slice(0, 70) +
              (q.label.length > 73 ? '…' : ''),
        val:  resolved.label ?? `Score ${score}`,
      });
    }
  });

  if (factors.length === 0) {
    factors.push({
      icon: '✅', bg: '#D1FAE5',
      name: 'No significant risk factors identified',
      val:  '0',
    });
  }
  return factors.slice(0, 6);
};

// ────────────────────────────────────────────────────────────────────────────
// buildReviewSections
// ────────────────────────────────────────────────────────────────────────────
export const buildReviewSections = (assessmentType) => {
  const group = findGroupByTitle(assessmentType);
  if (!group) return [];
  return [{ label: group.group, step: 1 }];
};

// ────────────────────────────────────────────────────────────────────────────
// getAssessmentMeta
// ────────────────────────────────────────────────────────────────────────────
const STAGE_COLORS = {
  puberty:             '#EC4899',
  young_adult:         '#8B5CF6',
  mature_reproductive: '#6366F1',
  perimenopause:       '#F59E0B',
  menopause:           '#EF4444',
  postmenopause:       '#0EA5E9',
  senior:              '#14B8A6',
};

export const getAssessmentMeta = (assessmentType) => {
  const group = findGroupByTitle(assessmentType);
  if (!group) return { label: assessmentType, icon: '🩺', color: '#5B21B6' };
  return {
    label:       group.group,
    icon:        '🩺',
    color:       STAGE_COLORS[group.stageId] ?? '#5B21B6',
    description: (group.conditions || []).join(', '),
    stageLabel:  group.stageLabel,
  };
};

// ────────────────────────────────────────────────────────────────────────────
// Extras
// ────────────────────────────────────────────────────────────────────────────
export const getAllGroupsForStage = (stageId) =>
  ALL_GROUPS.filter((g) => g.stageId === stageId);

export const getGroupByTitle = findGroupByTitle;

export default {
  computeScore, computeDomains, computeRiskFactors,
  buildReviewSections, getAssessmentMeta,
  getAllGroupsForStage, getGroupByTitle,
};